/**
 * Datos del responsable del tratamiento (Decreto 1377 de 2013, art. 13.1).
 *
 * Único lugar donde viven: los textos legales, el visor y "Mi cuenta" los
 * leen de aquí.
 *
 * Mientras la SAS está en constitución, el responsable es el fundador y la
 * dirección y el teléfono son los suyos. Cuando la SAS quede inscrita se
 * cambian por los de la empresa (issue #803): `nombre`, `nit`, `direccion`,
 * `telefono` y `atencionReclamos`, y se quita `responsableTemporal`. Es un
 * cambio sustancial, así que va con una `LEGAL_VERSION` nueva.
 */
export const RESPONSABLE = {
  nombre: "Kaptar S.A.S. (en constitución)",
  nit: "En trámite",
  responsableTemporal: "Jorge Enrique Henao Rojas, fundador",
  domicilio: "Manizales, Caldas, Colombia",
  direccion: "Carrera 1 # 71-338",
  telefono: "+57 311 382 1150",
  correoDatos: "privacidad@kaptar.com.co",
  correoSoporte: "soporte@kaptar.com.co",
  correoSeguridad: "security@kaptar.com.co",
  atencionReclamos: "Jorge Enrique Henao Rojas, fundador",
} as const;
